import React, { useState } from "react";
import PropTypes from "prop-types";
import * as classes from "./SideMenu.module.css";
import Triangle from "../../assets/icons/inline/triangle.svg";
import { Link } from "gatsby";
import KDC_Logo from "../../assets/images/KDC_Logo_Black.svg";
import getLocalizedName from "../../utils/getLocalizedName";

const SideMenu = ({
  items,
  translations,
  locale,
  currentPage,
  finnishLanguage,
  backTo
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const halfItems = Math.ceil(items.length / 2);

  return (
    <div className={classes.sideMenu}>
      <div className={classes.language}>
        <button
          className={classes.btn}
          onClick={() => setDropdownOpen(!dropdownOpen)}
        >
          {getLocalizedName(locale, locale)}
          <img
            src={Triangle}
            alt="triangle"
            className={dropdownOpen ? classes.downArrow : classes.rightArrow}
          />
        </button>

        <div
          className={`${classes.localeContainer} ${
            dropdownOpen ? classes.visible : ""
          }`}
          onClick={() => setDropdownOpen(false)}
          onKeyDown={() => setDropdownOpen(false)}
          role="button"
          tabIndex="0"
        >
          <div className={classes.language}></div>

          <div className={classes.locale}>
            {Object.keys(translations).map((t) => (
              <Link key={t} to={translations[t]}>
                {getLocalizedName(t, locale)}
              </Link>
            ))}
          </div>
        </div>
      </div>
      <Link
        to={finnishLanguage ? "/fi/" : "/"}
        className={`${classes.menuLink} ${classes.homeLink} ${
          currentPage === null ? classes.currentPage : ""
        }`}
      >
        {items[0].title}
      </Link>
      <div className={classes.verticalMenu}>
        <div className={classes.links}>
          <div className={classes.linksBox}>
            {items
              .filter((item, index) => {
                return index < halfItems;
              })
              .filter((item) => {
                return item.page.slug !== null;
              })
              .map((item) => {
                return (
                  <Link
                    key={item.id}
                    to={
                      item.page.slug
                        ? finnishLanguage
                          ? `/fi/${item.page.slug}`
                          : `/${item.page.slug}`
                        : "/"
                    }
                    className={`${classes.menuLink} ${
                      currentPage === item.page.slug ? classes.currentPage : ""
                    }`}
                  >
                    {item.title}
                  </Link>
                );
              })}
          </div>
          <div className={classes.linksBox}>
            {items
              .filter((item, index) => {
                return index >= halfItems;
              })
              .map((item) => {
                return (
                  <Link
                    key={item.id}
                    to={
                      item.page.slug
                        ? finnishLanguage
                          ? `/fi/${item.page.slug}`
                          : `/${item.page.slug}`
                        : "/"
                    }
                    className={`${classes.menuLink} ${
                      currentPage === item.page.slug ? classes.currentPage : ""
                    }`}
                  >
                    {item.title}
                  </Link>
                );
              })}
          </div>
        </div>
        <div className={classes.bottom}>
          <a href="https://kyrodistillery.com/" className={classes.menuLink}>
            {backTo}
          </a>
          <img src={KDC_Logo} alt="KDC Logo" />
        </div>
      </div>
    </div>
  );
};

SideMenu.propTypes = {
  items: PropTypes.array.isRequired,
  translations: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  currentPage: PropTypes.string,
  finnishLanguage: PropTypes.bool,
  backTo: PropTypes.string.isRequired
};

export default SideMenu;
